// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#Examples
const secureMathRandom = (): number =>
  window.crypto.getRandomValues(new Uint32Array(1))[0] / 4294967295

const random = (min = 0, max = 1): number =>
  secureMathRandom() * (max - min) + min

export default random
